export default "__VITE_ASSET__DSminlnx__"